export const FormatsData: import('../../../sim/dex-species').ModdedSpeciesFormatsDataTable = {
	krokorok: {
		tier: "OU",
		doublesTier: "DOU",
	},
	qwilfishhisui: {
		tier: "OU",
		doublesTier: "DOU",
	},
	snivy: {
		tier: "OU",
		doublesTier: "DOU",
	},
	dragonair: {
		tier: "OU",
		doublesTier: "DOU",
	},
	wimpod: {
		tier: "OU",
		doublesTier: "DOU",
	},
	toxelhisui: {
		tier: "OU",
		doublesTier: "DOU",
	},
	tadbulb: {
		tier: "OU",
		doublesTier: "DOU",
	},
	pikipek: {
		tier: "OU",
		doublesTier: "DOU",
	},
	chingling: {
		tier: "OU",
		doublesTier: "DOU",
	},
	baltoygearrider: {
		tier: "OU",
		doublesTier: "DOU",
	},
	baltoywaterrider: {
		tier: "OU",
		doublesTier: "DOU",
	},
	charmander: {
		tier: "OU",
		doublesTier: "DOU",
	},
	nymble: {
		tier: "OU",
		doublesTier: "DOU",
	},
	vanillite: {
		tier: "OU",
		doublesTier: "DOU",
	},
	spheal: {
		tier: "OU",
		doublesTier: "DOU",
	},
	anorith: {
		tier: "OU",
		doublesTier: "DOU",
	},
	jigglypuff: {
		tier: "OU",
		doublesTier: "DOU",
	},
	bronzor: {
		tier: "OU",
		doublesTier: "DOU",
	},
	wiglett: {
		tier: "OU",
		doublesTier: "DOU",
	},
	gible: {
		tier: "OU",
		doublesTier: "DOU",
	},
	vulpix: {
		tier: "OU",
		doublesTier: "DOU",
	},
	shuppet: {
		tier: "OU",
		doublesTier: "DOU",
	},
	golett: {
		tier: "OU",
		doublesTier: "DOU",
	},
	elgyem: {
		tier: "OU",
		doublesTier: "DOU",
	},
	farfetchd: {
		tier: "OU",
		doublesTier: "DOU",
	},
	amaura: {
		tier: "OU",
		doublesTier: "DOU",
	},
	wailmer: {
		tier: "OU",
		doublesTier: "DOU",
	},
	pikachu: {
		tier: "OU",
		doublesTier: "DOU",
	},
	pikachuhoenn: {
		tier: "Illegal",
		doublesTier: "Illegal",
	},
	pikachucosplay: {
		tier: "Illegal",
		doublesTier: "Illegal",
	},
	pikachurockstar: {
		tier: "Illegal",
		doublesTier: "Illegal",
	},
	pikachubelle: {
		tier: "Illegal",
		doublesTier: "Illegal",
	},
	pikachupopstar: {
		tier: "Illegal",
		doublesTier: "Illegal",
	},
	pikachuphd: {
		tier: "Illegal",
		doublesTier: "Illegal",
	},
	pikachulibre: {
		tier: "Illegal",
		doublesTier: "Illegal",
	},
	pikachuoriginal: {
		tier: "Illegal",
		doublesTier: "Illegal",
	},
	pikachusinnoh: {
		tier: "Illegal",
		doublesTier: "Illegal",
	},
	pikachuunova: {
		tier: "Illegal",
		doublesTier: "Illegal",
	},
	pikachukalos: {
		tier: "Illegal",
		doublesTier: "Illegal",
	},
	pikachualola: {
		tier: "Illegal",
		doublesTier: "Illegal",
	},
	pikachupartner: {
		tier: "Illegal",
		doublesTier: "Illegal",
	},
	pikachuworld: {
		tier: "Illegal",
		doublesTier: "Illegal",
	},
	pikachustarter: {
		tier: "Illegal",
		doublesTier: "Illegal",
	},
	morelull: {
		tier: "OU",
		doublesTier: "DOU",
	},
	ditto: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	// Slate 2
	amauramega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	pikachumega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	dragonairmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	houndour: {
		tier: "OU",
		doublesTier: "DOU",
	},
	koffing: {
		tier: "OU",
		doublesTier: "DOU",
	},
	maushold: {
		tier: "OU",
		doublesTier: "DOU",
	},
	hakamoo: {
		tier: "OU",
		doublesTier: "DOU",
	},
	kartana: {
		tier: "OU",
		doublesTier: "DOU",
	},
	ledyba: {
		tier: "OU",
		doublesTier: "DOU",
	},
	wooperpaldea: {
		tier: "OU",
		doublesTier: "DOU",
	},
	hoothoot: {
		tier: "OU",
		doublesTier: "DOU",
	},
	rabootsinnoh: {
		tier: "OU",
		doublesTier: "DOU",
	},
	honedge: {
		tier: "OU",
		doublesTier: "DOU",
	},
	roselia: {
		tier: "OU",
		doublesTier: "DOU",
	},
	skiploom: {
		tier: "OU",
		doublesTier: "DOU",
	},
	spritzee: {
		tier: "OU",
		doublesTier: "DOU",
	},
	helioptile: {
		tier: "OU",
		doublesTier: "DOU",
	},
	piplup: {
		tier: "OU",
		doublesTier: "DOU",
	},
};
